import Icon from "@mui/icons-material/Event";

import MiqaatCreate from "./MiqaatCreate";
import MiqaatEdit from "./MiqaatEdit";
import MiqaatList from "./MiqaatList";
import MiqaatShow from "./MiqaatShow";

export default {
  list: MiqaatList,
  create: MiqaatCreate,
  edit: MiqaatEdit,
  show: MiqaatShow,
  icon: Icon,
  label: "Miqaats",
  options: { label: "Miqaats" },
  name: "miqaats",
};
